import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SignAndSubmitComponent } from '../dialogs/sign-and-submit/sign-and-submit.component';
import { OpportunitiesService } from '../services/opportunities.service';
import { OpportunitySnapshotsService } from '../services/opportunity-snapshots.service';
import { SurplusLinesDocument } from '../models/surplus-lines-document.model';
import { forkJoin } from 'rxjs';
import { PaymentsService } from '../services/payments.service';

@Component({
  selector: 'app-sign',
  standalone: false,
  templateUrl: './sign.component.html',
  styleUrl: '../../assets/css/HighLimits.css'
})
export class SignComponent implements OnInit {
  statement1: boolean = false;
  statement2: boolean = false;
  statement3: boolean = false;
  statement4: boolean = false;
  linksChecked: boolean[] = [];
  percent = 90;
  documents: SurplusLinesDocument[] = [];
  total: number = 0;

  readonly dialog = inject(MatDialog);
  snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000
  };

  constructor(
    private _snackbar: MatSnackBar,
    private _router: Router,
    private _opportunityService: OpportunitiesService,
    private _oss: OpportunitySnapshotsService,
    private _paymentsService: PaymentsService
  ) {}

  ngOnInit() {
    const opportunityId = this._oss.currentOpportunitySnapshot.OpportunityId;

    const currentQuarterly = this._paymentsService.getCurrentQuarterlyPayment();
    const currentAnnual = this._paymentsService.getCurrentAnnualPayment();
    this.total = currentQuarterly !== null ? currentQuarterly :  Number(currentAnnual);

     this._paymentsService.quarterlyPayment$.subscribe(amount => {
      if (amount !== null) {
        this.total = amount;
      }
    });
    
    this._opportunityService.getDocuments(opportunityId).subscribe(documents => {
      this.documents = documents;
      this.linksChecked = new Array(this.documents.length).fill(false);
    });
}

  signAndSubmit() {
    if (this.statement1 && this.statement2 && this.statement3 && this.linksChecked.every(link => link)) {
      let dialogRef = this.dialog.open(SignAndSubmitComponent, {
        height: '250px',
        width: '300px',
        disableClose: true,
      });
      dialogRef.updatePosition({ top: '150px' });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          this._snackbar.open('Signature process was canceled.', 'Close', this.snackBarConfig);
          return;
        }

        const fullName = `${this._oss.CurrentUser?.FirstName ?? ''} ${this._oss.CurrentUser?.LastName ?? ''}`.trim();
        const signatureDate = new Date().toLocaleDateString();

        const saveRequests = this.documents.map(document => {
        const sigField = document.Fields.find(field => field.Name === "Signature");
        const sigDateField = document.Fields.find(field => field.Name === "SignatureDate");

        if (sigField) sigField.Value = fullName;
        if (sigDateField) sigDateField.Value = signatureDate;

        return this._opportunityService.saveDocument(this._oss.currentOpportunitySnapshot.OpportunityId, document);
      });

        forkJoin(saveRequests).subscribe({
          next: () => {
            this.percent = 100;
            this._router.navigate(['/receipt']);
          },
          error: (err) => {
            console.error('Failed to save all documents:', err);
            this._snackbar.open('An error occurred while saving documents.', 'Close', this.snackBarConfig);
          }
        });
      });

    } else {
      this._snackbar.open('Please agree to all statements', 'Close', this.snackBarConfig);
    }
}

  gotoPay() {
    this._router.navigate(['/payment']);
  }

  gotoSign() {
    this._router.navigate(['/sign']);
  }

  gotoQuote() {
    this._router.navigate(['/quote']);
  }

  gotoQuestionnaire() {
    this._router.navigate(['/questionnaire']);
  }
}
